<template>
  <pt-create-report-unscramble-apply class="pt-create-report-unscramble-apply__withData"></pt-create-report-unscramble-apply>
</template>

<script>
import PtCreateReportUnscrambleApply from './index'
export default {
  name: 'pt-create-report-unscramble-apply__withData',
  components: {
    'pt-create-report-unscramble-apply': PtCreateReportUnscrambleApply
  }
}
</script>
